/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import {Input, Button, ButtonGroup, ButtonToolbar, Row, Col, FormGroup, Label} from 'reactstrap'
import Select from 'react-select'
import DropDownTreeSelect from 'react-dropdown-tree-select-sco'
import 'react-dropdown-tree-select-sco/dist/styles.css'

class QueryBuilder extends React.Component
{
  operators = [{label: '=', value: '='}, {label: '!=', value: '!='}];
  
  filterDataChanged(index, filterData)
  {
    this.props.filterDataChanged(index, filterData); 
  }

  matchAnyOrAllChanged(matchAnyOrAll)
  {
    this.props.matchAnyOrAllChanged(matchAnyOrAll);
  }

  onKeywordChangeHandler(index, currentNode, selectedNodes)
  {
    var selectedValue = null;
    if (selectedNodes.length) selectedValue = currentNode.value;
    
    var filterData = this.props.filterData[index];
    if (null === selectedValue) 
      filterData.queryValue = null;
    else if (null !== filterData.queryKeyword && selectedValue.keywordId !== filterData.queryKeyword.keywordId) 
      filterData.queryValue = null;

    filterData.queryKeyword = selectedValue;
    this.filterDataChanged(index, filterData);
  }

  onValueChangeHandler(index, selectedValue, actionMetaD)
  {
    let filterData = this.props.filterData[index];
    filterData.queryValue = selectedValue;
    this.filterDataChanged(index, filterData);
  }

  operatorChanged(index, operator)
  {
    let filterData = this.props.filterData[index];
    filterData.operator = operator;
    this.props.filterDataChanged(index, filterData);
  }

  render()
  {
    let returnArray = [];

    let valueIsClearable = (1 === this.props.filterData.length ? true : false);

    for (let x = 0; x < this.props.filterData.length; x++)
    {
      let keywordGroups = [];
      let lastKeywordGroup = null;
      if (undefined !== this.props.queryKeywords[x])
      {
        for (let y = 0; y < this.props.queryKeywords[x].length; y++)
        {
          if (lastKeywordGroup !== this.props.queryKeywords[x][y].keywordGroup)
          {
            lastKeywordGroup = this.props.queryKeywords[x][y].keywordGroup;
            let keywordGroup = { label: this.props.queryKeywords[x][y].keywordGroup, value: '', children: []};
            keywordGroups.push(keywordGroup);
          }

          let checked = false;
          if (null !== this.props.filterData[x].queryKeyword &&
              this.props.queryKeywords[x][y].keywordId === this.props.filterData[x].queryKeyword.keywordId)
            checked = true;
          let keyword = 
          { 
            label: this.props.queryKeywords[x][y].keyword, 
            value: this.props.queryKeywords[x][y],
            tagLabel: this.props.queryKeywords[x][y].keywordGroup + ' - ' + this.props.queryKeywords[x][y].keyword,
            checked: checked
          }
          keywordGroups[keywordGroups.length-1].children.push(keyword);
        }
      }

      let key = 'queryFilter' + x;
      let zIndex = 1000 - x;
      let valueDisabled = true;

      if (null !== this.props.filterData[x].queryKeyword) valueDisabled = false;

      returnArray[x] = 
      (
        <div key={key} z-index={zIndex}>
          <Row>
            <Col>
              <DropDownTreeSelect data={keywordGroups} className={'bootstrap-demo'} selectChildrenOnly={true} mode={'radioSelect'}
                onChange={this.onKeywordChangeHandler.bind(this, x)} />
            </Col>
          </Row>
          <Row>
            <Col sm={{ size: 3, offset: 1 }} className={"pr-0"}>
              <Select id='operatorSelect' value={undefined !== this.props.filterData[x].operator ? this.props.filterData[x].operator : {label: '=', value: '='}} 
                options={this.operators} clearable={false} onChange={this.operatorChanged.bind(this, x)} />
            </Col>
            <Col>
              <Select value={this.props.filterData[x].queryValue} 
                options={undefined !== this.props.queryValues ? this.props.queryValues[x] : null} 
                onChange={this.onValueChangeHandler.bind(this, x)} 
                isDisabled={valueDisabled} getOptionValue={option => option.valueId} getOptionLabel={option => option.keywordValue} 
                closeMenuOnSelect={true} placeholder="Select a value..." isClearable={valueIsClearable}
              />
            </Col>
          </Row>
          <Row><Col><hr></hr></Col></Row>          
        </div>
      )
    }

    let clearAllFiltersDisabled = true;

    if (1 === this.props.filterData.length && null === this.props.filterData[this.props.filterData.length - 1].queryValue) return returnArray;
    if (1 < this.props.filterData.length) clearAllFiltersDisabled = false;

    returnArray[returnArray.length] = 
    (
      <div key='queryBuilderButtonBar'>
        <Row>
            <Col>
            <ButtonToolbar>
              <ButtonGroup >
                <Button title="Add Filter" color="transparent" onClick={this.props.addFilter}><img src="assets/images/plus.png" alt="Add another filter" /></Button>
                <Button title="Clear Filters" color="transparent" onClick={this.props.clearAllFilters} disabled={clearAllFiltersDisabled}><img src="assets/images/eraser.png" alt="Remove all filters" /></Button>
                </ButtonGroup>
            </ButtonToolbar></Col>
            { 2 <= returnArray.length &&
              <Col style={{paddingTop: "10px"}} sm={8}>Match Filters?&nbsp;
                <FormGroup check className="form-check-inline">
                  <Label check>
                  <Input type="radio" name="anyOrAllRadios" onChange={this.matchAnyOrAllChanged.bind(this, 'All')} 
                    checked={('All' === this.props.matchAnyOrAll)}
                  /> 
                  All
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="anyOrAllRadios" onChange={this.matchAnyOrAllChanged.bind(this, 'Any')} 
                    checked={('Any' === this.props.matchAnyOrAll)}
                  /> 
                  Any
                </Label>
              </FormGroup>
            </Col>
            }
        </Row>
      </div>
    );

    return returnArray;
  }
}

export default QueryBuilder